export const init = () => {
    // Funkce pro nastavení výšky elementů
    const setEqualHeights = (container) => {
        const titles = container.querySelectorAll('.js-title');
        const perexes = container.querySelectorAll('.js-perex');
        
        if (titles.length) {
            const maxTitleHeight = Math.max(...Array.from(titles).map(item => item.clientHeight));
            titles.forEach(item => item.style.height = `${maxTitleHeight}px`);
        }
        
        if (perexes.length) {
            const maxPerexHeight = Math.max(...Array.from(perexes).map(item => item.clientHeight));
            perexes.forEach(item => item.style.height = `${maxPerexHeight}px`);
        }
    };

    // Funkce pro inicializaci
    const initializeProductGallery = (container) => {
        if (container.querySelector('.s-product-gallery')) {
            container.querySelectorAll('.s-product-gallery').forEach(item => {
                setEqualHeights(item);
            });
        }
    };

    // Inicializace všech existujících produktových galerií
    initializeProductGallery(document.body);

    // Nastavení MutationObserveru
    const setupMutationObserver = () => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1 && node.matches('.s-product-gallery')) {
                            initializeProductGallery(document.body);
                        }
                    });
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    // Nastavení observeru
    setupMutationObserver();
};